import styled from 'styled-components';
import TickIconSvg from '../assets/hotels/review/tick.svg';

const TickIcon = styled(TickIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)(
  props => `

    fill: ${props.theme.colors.downriver.medium};
`,
);

export default TickIcon;
